import {gettext, interpolate} from 'topmeteo/utils/i18n';

const className = 'expiration-date';

const Label = gettext('Expiration date: %(date)s');

const getLabel = ({label}) => interpolate(Label, {date: label});

const isAvailable = ({expirationDate}) => Boolean(expirationDate);

const getProps = ({expirationDate}) => ({
    label: getLabel(expirationDate),
});

export default {className, isAvailable, getProps};
